import { render, staticRenderFns } from "./VariantItemFlat.vue?vue&type=template&id=99cb7160&scoped=true"
import script from "./VariantItemFlat.vue?vue&type=script&lang=js"
export * from "./VariantItemFlat.vue?vue&type=script&lang=js"
import style0 from "./VariantItemFlat.vue?vue&type=style&index=0&id=99cb7160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb7160",
  null
  
)

export default component.exports